import {
  animate,
  AUTO_STYLE,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { INavbarData } from './sidenav.interface';

export const navbarData: INavbarData[] = [];

export const VEHICLE_ICON = [
  'sprite.svg#truck',
  'sprite.svg#tractor',
  'sprite.svg#superAuto',
  'sprite.svg#scv',
  'sprite.svg#vehicleToggle',
];

export const VEHICLE_IMG = [
  'Truck.svg',
  'Tractor.svg',
  '3-Wheeler.svg',
  'SCV.svg',
  'vehicleToggle',
];

// animation

export const hideShow = trigger('collapse', [
  state(
    'false',
    style({ height: AUTO_STYLE, visibility: AUTO_STYLE, overflow: 'hidden' })
  ),
  state(
    'true',
    style({ height: '0', visibility: 'hidden', overflow: 'hidden' })
  ),
  transition('false => true', animate('{{duration}}ms ease-in')),
  transition('true => false', animate('{{duration}}ms ease-out')),
]);
